import { INTELLIGENT_PHOTO_CAPTURE_CREATE_ATTACHMENT_BATCH_ACTIVITY_INFO, INTELLIGENT_PHOTO_CAPTURE_UPDATE_BATCH_STATUS } from '../actions';
import { attachmentBatchActivityInfo } from '../utilities';
export const photoCaptureIntelligentAttachmentBatchActivityInfoReducer = (state, action) => {
    switch (action.type) {
        case INTELLIGENT_PHOTO_CAPTURE_CREATE_ATTACHMENT_BATCH_ACTIVITY_INFO:
            const { batchId, files } = action.payload;
            const batchActivityInfo = attachmentBatchActivityInfo.createBatchActivityInfo(batchId, files, state.attachmentInfo);
            return Object.assign(Object.assign({}, state), { attachmentBatchActivityInfo: [...(state.attachmentBatchActivityInfo || []), batchActivityInfo] });
        case INTELLIGENT_PHOTO_CAPTURE_UPDATE_BATCH_STATUS:
            return Object.assign(Object.assign({}, state), { attachmentBatchActivityInfo: attachmentBatchActivityInfo.updateBatchActivityInfo(state.attachmentBatchActivityInfo || [], action.payload.batchId) });
        default:
            return state;
    }
};
//# sourceMappingURL=photoCaptureIntelligentAttachmentBatchActivityInfoReducer.js.map